import React from "react";

export default function WhyAkten() {
  const features = [
    {
      title: "US-Based Active Company",
      description: "Registered and active US corporation",
      image: "/site-images/0958cb6d688cd1e76e40.jpg",
      icon: "ri-map-pin-line",
    },
    {
      title: "Compliance First",
      description: "Fully compliant wholesale operations",
      image: "/site-images/653a5744f291c03bdf47.jpg",
      icon: "ri-shield-check-line",
    },
    {
      title: "Long-Term Partnership",
      description: "Sustainable business relationships",
      image: "/site-images/093d728eb13b78b9a7e8.jpg",
      icon: "ri-hand-heart-line",
    },
    {
      title: "Transparent Communication",
      description: "Professional and open dialogue",
      image: "/site-images/3fbae6db6a8399c46a41.jpg",
      icon: "ri-message-3-line",
    },
  ];

  return (
    <section id="about" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <p className="text-sm font-medium text-gray-500 tracking-wider uppercase mb-3">
            WHY AKTEN INC
          </p>
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 max-w-3xl">
            Reliable and Professional{" "}
            <span className="italic font-serif">Partnership</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="rounded-3xl overflow-hidden flex flex-col"
            >
              <div className="relative h-64 flex items-center justify-center">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-[#1a2332]/55"></div>
                <i className={`${feature.icon} text-white text-6xl relative z-10`}></i>
              </div>
              <div className="bg-white p-6 border border-gray-200 rounded-b-3xl flex-1">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-sm">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gray-50 rounded-3xl p-10 border border-gray-200">
          <div className="flex items-start space-x-4">
            <div className="w-12 h-12 rounded-full bg-akten flex items-center justify-center flex-shrink-0">
              <i className="ri-close-circle-line text-white text-2xl"></i>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                No Arbitrage or Unauthorized Resale
              </h3>
              <p className="text-gray-600 leading-relaxed">
                We only work with authorized supply chains. We do not engage in arbitrage
                or unauthorized resale activities.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}